export default {
	name: 'TypeCondition',
	props: {
		value: {
			type: Number
		},
		carTypes: {
			type: Array,
			default: []
		}
	},
	data () {
		return {
			val: this.value || null
		}
	},
	template: `
	<div class="m-sch -sp-space">
		<select class="m-sch__select -size-m" v-model="val">
			<option :value="null">指定なし</option>
			<option v-for="type in carTypes" :key="type.id"
				:value="type.id">{{ type.name }}</option>
		</select>
	</div>
	`,
	watch: {
		val () {
			this.$emit('input', this.val)
		}
	}
}
